<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 60px; top: 116px">
      <p>
        Para realizar esta actividad vuelve a leer el poema "El sapito Glo Glo
        Glo".
      </p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 60px; top: 165px">
      <p>Completa el resumen.</p>
    </span>

    <p id="tag01" class="textBase basicItem01 tagDefault">SE ESCONDE.</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">GLO GLO GLO.</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">ESCUCHAR.</p>
    <p id="tag04" class="textBase basicItem01 tagDefault">CUANDO LLUEVE</p>
    <p id="tag05" class="textBase basicItem01 tagDefault">SAPITO.</p>

    <h2 id="text01" class="textBase textFormat21">GLO GLO GLO ES UN</h2>
    <h2 id="text02" class="textBase textFormat21">QUE CANTA</h2>
    <h2 id="text03" class="textBase textFormat21">PERO NADIE SABE DÓNDE</h2>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
      class="pageElement"
    />
  </div>
</template>
<style scoped>
#inputField01 {
  position: absolute;
  width: 585px;
  height: 50px;
  left: 380px;
  top: 415px;
}
#inputField02 {
  position: absolute;
  width: 710px;
  height: 50px;
  left: 255px;
  top: 507px;
}
#inputField03 {
  position: absolute;
  width: 518px;
  height: 50px;
  left: 447px;
  top: 593px;
}
#tag01 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 71px;
  top: 225px;
}
#tag02 {
  position: absolute;
  width: 300px;
  text-align: center;
  left: 351px;
  top: 225px;
}
#tag03 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 701px;
  top: 225px;
}
#tag04 {
  position: absolute;
  width: 300px;
  text-align: center;
  left: 209px;
  top: 315px;
}
#tag05 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 561px;
  top: 315px;
}

#text01 {
  position: absolute;
  left: 74px;
  top: 440px;
}
#text02 {
  position: absolute;
  left: 74px;
  top: 525px;
}
#text03 {
  position: absolute;
  left: 74px;
  top: 615px;
}
.textFormat21 {
  font-size: 29px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "glo/Video 97.mp4",
        "glo/Video 98.mp4",
        "glo/Video 99.mp4",
        "glo/Video 100.mp4",
        "glo/Video 102.mp4",
        "glo/Video 104.mp4",
        "glo/Video 105.mp4",
        "glo/Video 106.mp4",
        "glo/Video 107.mp4",
        "glo/Video 108.mp4",
      ]
    }
  }
}
</script>